<template>
    <div class="quiz">
        <div class="widget" v-if="component_type === 'widget'">
            <h5>{{quiz_name}}</h5>
            <span class="question mb-3">{{currentQuestion.question}}</span>
            <label v-for="(choiceId) in currentQuestion.randomOrder"
                   class="quizAnswer"
                   :for="'quiz_'+choiceId"
                   @mousedown="selectAnswer(choiceId)"
            >
                {{currentQuestion.choices[choiceId].title}}
                <input v-if="currentQuestion.type === 'simple'" type="radio" :name="currentQuestion.title" value="choiceId" :id="'quiz_'+choiceId">
                <input v-if="currentQuestion.type === 'multiple'" type="checkbox" :name="currentQuestion.title" value="choiceId" :id="'quiz_'+choiceId">
                <span :class="{
                    'custom-radio' : currentQuestion.type === 'simple',
                    'custom-check' : currentQuestion.type === 'multiple',
                    'selected' : (selectedAnswer.indexOf(choiceId) >= 0),
                    'correct' : (currentQuestion.answered && selectedAnswer.indexOf(choiceId) >= 0 && currentQuestion.correctAnswer.indexOf(choiceId) >= 0),
                    'wrong' : (currentQuestion.answered && selectedAnswer.indexOf(choiceId) >= 0 && currentQuestion.correctAnswer.indexOf(choiceId) < 0),
                    'correctChoice' : (currentQuestion.answered && selectedAnswer.indexOf(choiceId) < 0 && currentQuestion.correctAnswer.indexOf(choiceId) >= 0),
                  }"
                ></span>
            </label>
            <span class="answer"
                  :class="{
                'corrrect': currentQuestion.correct
              }"
                  v-if="currentQuestion.answered"
                  v-text="currentQuestion.correct ? correct_label : wrong_label"
            ></span>
            <span class="next btn btn-disabled" v-if="!this.questions[this.current].answered" @click="checkAnswer" v-text="check_label"></span>
            <span class="next btn btn-primary" v-if="this.questions[this.current].answered && this.current < this.questions.length-1" @click="nextAnswer" v-text="next_label"></span>
        </div>
        <div class="quiz-component p-5"
             v-if="component_type === 'component'"
             :class="{'hide-controlls' : this.isFinished}"
         >
            <header class="mb-4">{{quiz_name}}</header>
            <VueSlickCarousel
                    ref="slick"
                    v-bind="slickSettings"
                    class="article-slider-content"
                    v-if="questions.length > 0"
                    @beforeChange="slideChangeBefore"
            >
                <article class="component-item pl-5 pr-5" v-for="q in questions">
                    <h5 class="mb-4">{{q.question}}</h5>
                    <div class="row">
                        <div class="col-12 col-md-4 text-right p-0" v-if="q.image"><img :src="q.image" loading="lazy"/></div>
                        <div class="col-12 col-md-8 text-left pt-2 pl-4" :class="{'offset-md-6' : !q.image}"
                            v-if="questions[current]">
                            <label v-for="(choiceId) in q.randomOrder"
                                   class="quizAnswer"
                                   :for="'quiz_'+choiceId"
                                   @mousedown="selectAnswer(choiceId)"
                            >
                                {{q.choices[choiceId].title}}
                                <input v-if="q.type === 'simple'" type="radio" :name="q.title" value="choiceId" :id="'quiz_'+choiceId">
                                <input v-if="q.type === 'multiple'" type="checkbox" :name="q.title" value="choiceId" :id="'quiz_'+choiceId">
                                <span :class="{
                                    'custom-radio' : questions[current].type === 'simple',
                                    'custom-check' : questions[current].type === 'multiple',
                                    'selected' : (selectedAnswer.indexOf(choiceId) >= 0),
                                    //'correct' : (questions[current].answered && selectedAnswer.indexOf(choiceId) >= 0 && questions[current].correctAnswer.indexOf(choiceId) >= 0),
                                    //'wrong' : (questions[current].answered && selectedAnswer.indexOf(choiceId) >= 0 && questions[current].correctAnswer.indexOf(choiceId) < 0),
                                    //'correctChoice' : (questions[current].answered && selectedAnswer.indexOf(choiceId) < 0 && questions[current].correctAnswer.indexOf(choiceId) >= 0),
                                  }"
                                ></span>
                            </label>
                            <!--<span class="answer"
                                  :class="{
                                    'corrrect': currentQuestion.correct
                                  }"
                                  v-if="currentQuestion.answered"
                                  v-text="currentQuestion.correct ? correct_label : wrong_label"
                            ></span>-->
                            <span class="next btn btn-disabled" @click="checkAnswer" v-if="!questions[current].answered" v-text="check_label"></span>
                            <span class="next btn btn-primary" v-if="questions[current].answered && current <= questions.length" @click="nextAnswer" v-text="next_label"></span>
                        </div>
                    </div>
                </article>

                <article class="component-item result-slide pl-5 pr-5" :style="{'background-image' : 'url(https://eurofarma.com.br/' + bg_image + ')'}">
                    <div class="content">
                      <h5 class="title" v-html="result_texts.result"></h5>
                      <div class="percentage" v-text="renderResultPercentage()"></div>
                      <div class="big-text" v-text="renderResultTitle()"></div>
                      <div class="message" v-text="renderResultMessage()"></div>
                      <div class="share-buttons">
                        <span class="label" v-html="result_texts.share"></span>
                        <a class="btn btn-primary facebook-button" v-html="icons.facebook" target="_blank" :href="facebookUrl" ></a>
                        <a class="btn btn-primary twitter-button" v-html="icons.twitter"  target="_blank" :href="tweetUrl" ></a>
                        <a class="btn btn-primary mail-button" v-html="icons.mail" target="_blank" :href="mailToLink" ></a>
                      </div>
                      <a @click="restart()" class="btn btn-primary refresh-button" v-html="icons.refresh"></a>
                    </div>
                  <a v-if="page_related" :href="page_related" class="btn btn-yellow right-positon">Saiba Mais</a>

                  <div class="disclaimer">
                      <span class="title" v-html="result_texts.disclaimer_title"></span>
                      <span class="text" v-html="result_texts.disclaimer"></span>
                    </div>
                </article>

            </VueSlickCarousel>
        </div>
    </div>
</template>

<script>

import VueSlickCarousel from "vue-slick-carousel";

export default {
    components: {VueSlickCarousel},
    props: {
        quiz_id: Number,
        quiz_data: Object,
        result_titles: Object,
        result_messages: Object,
        result_percentage: Object,
        result_texts: Object,
        bg_image: String,
        check_label: String,
        correct_label: String,
        wrong_label: String,
        next_label: String,
        component_type: String,
        quiz_name: String,
        page_related: String
    },
    data: () => {
        return {
            questions: [],
            current: 0,
            currentSlide: 0,
            isFinished: false,
            selectedAnswer: [],
            resultCorrect: 0,
            resultPercent: 0,
            facebookUrl: '',
            tweetUrl: '',
            mailToLink: '',
            icons: {
              refresh : '',
              facebook : '',
              twitter : '',
              mail : ''
            },
            slickSettings: {
                arrows: false,
                adaptiveHeight: true,
                draggable: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                swipe: false,
                infinite: false,
                speed: 300,
                variableWidth: false,
            }
        }
    },
    computed:{
        currentQuestion: function(){
            return this.questions[this.current]
        },
        totalQuestions: function() {
            return this.questions.length;
        }
    },
    beforeMount() {
      this.icons.refresh = document.getElementById('refresh-quiz-icon').innerHTML;
      this.icons.facebook = document.getElementById('facebook-quiz-icon').innerHTML;
      this.icons.twitter = document.getElementById('twitter-quiz-icon').innerHTML;
      this.icons.mail = document.getElementById('mail-quiz-icon').innerHTML;
      this.resetQuestions();
    },
    mounted(){

    },
    methods:{
        generateRandomOrder(question){
            let firstOrder = Object.keys(question.choices);

            question.randomOrder = [];
            question.correctAnswer = [];

            while(firstOrder.length > 0){
                let index = Math.floor(Math.random() * (firstOrder.length));
                question.randomOrder.push(firstOrder[index]);
                if(question.choices[firstOrder[index]].correct) question.correctAnswer.push(firstOrder[index]);
                firstOrder.splice(index,1);
            }
        },

        selectAnswer(choice){

            if(this.answered) {
                return;
            }

            this.currentQuestion.answers += 1;

            if(this.currentQuestion.type === 'simple') {
                this.selectedAnswer = [];
            }

            if(this.selectedAnswer.indexOf(choice) < 0) {
                this.selectedAnswer.push(choice);
            } else {
                this.selectedAnswer.splice(this.selectedAnswer.indexOf(choice), 1);
            }

            this.checkAnswer()
        },

        checkAnswer(){

            //Continue if need more answers
            if(this.currentQuestion.type === 'multiple' && this.questions[this.current].answers !== this.questions[this.current].correctAnswer.length) {
                return false;
            }

            let question = this.questions[this.current];
            let thisAnswers = [];
            this.selectedAnswer.slice().forEach(function (item, index) {
                if(item.indexOf(question.id) !==  -1) {
                  thisAnswers.push(item);
                }
            });

            this.questions[this.current].correct = thisAnswers.slice().sort().join(",") === this.questions[this.current].correctAnswer.slice().sort().join(",");
            this.questions[this.current].answered = true;

            if (this.questions[this.current].correct) {
                this.resultCorrect = this.resultCorrect + 1;
            }

            this.resultPercent = Math.ceil((this.resultCorrect / this.questions.length) * 100);
            this.generateShareUrls();

            this.$forceUpdate()
        },

        nextAnswer(){

            if(this.component_type === 'component'){
                this.$refs.slick.next();
                return;
            }

            if(this.current >= this.questions.length) {
                return;
            }

            this.answered = false;
            this.selectedAnswer = [];
            this.current ++;

        },

        restart() {
            this.current = 0;
            this.resultCorrect = 0;
            this.selectedAnswer = [];
            this.answered = false;
            this.isFinished = false;
            this.$refs.slick.goTo(0);

            this.resetQuestions();

            this.$forceUpdate();
        },

        resetQuestions() {
            Object.keys(this.quiz_data).forEach((questionID, index)=>{
                this.questions[index] = this.quiz_data[questionID];
                this.questions[index].id = questionID;
                this.questions[index].answered = false;
                this.questions[index].correct = false;
                this.questions[index].answers = 0;
                this.generateRandomOrder(this.questions[index])
            })
        },

        slideChangeBefore(oldSlideIndex,newSlideIndex){

            this.current = newSlideIndex;

            if(newSlideIndex === this.questions.length) {
              this.isFinished = true;
            }else{
              this.isFinished = false;
            }

        },

        getPercentageIndex() {

          if (this.resultPercent <= 16) {
            return 1;
          }

          if (this.resultPercent <= 34) {
            return 2;
          }

          if (this.resultPercent <= 52) {
            return 3;
          }

          if (this.resultPercent <= 59) {
            return 4;
          }

          if (this.resultPercent <= 85) {
            return 5;
          }

          return 6;

        },

        renderResultTitle() {
          return this.result_titles[this.getPercentageIndex()];
        },

        renderResultMessage() {
          return this.result_messages[this.getPercentageIndex()];
        },

        renderResultPercentage() {
          return this.result_percentage[this.getPercentageIndex()];
        },

        generateShareUrls() {
          let textToShare = '';
              textToShare += this.result_titles[this.getPercentageIndex()] + ' ';
              textToShare += this.result_messages[this.getPercentageIndex()] + ' ';
              textToShare += '\nEu acertei de ';
              textToShare += this.result_percentage[this.getPercentageIndex()] + ' ';
              textToShare += ', e você? \n';

          textToShare = encodeURI(textToShare);

          this.facebookUrl = 'https://www.facebook.com/dialog/feed?app_id=2404781719741671&display=popup&link=https://eurofarma.com.br/quiz/' + this.quiz_id + '&quote=' + textToShare;
          this.tweetUrl = 'https://twitter.com/intent/tweet?hashtags=quiz%2Ceurofarma&original_referer=https%3A%2F%2Feurofarma.com.br/quiz/' + this.quiz_id + '&ref_src=twsrc%5Etfw&related=twitterapi%2Ctwitter&text=' + textToShare + '&tw_p=tweetbutton&url=https%3A%2F%2Feurofarma.com.br/quiz/' + this.quiz_id + '&via=eurofarma';
          this.mailToLink = 'mailto:?subject=Quiz Eurofarma ' + this.result_texts.result + '&body=' + textToShare;

        }
    },
}
</script>
